import http from "../../utils/http"

/**
 * 获取新闻列表
 */
export function newsList(params) {
    return http({
        url: "/api/news/page",
        data: params
    })
}

/**
 * 获取新闻分类列表
 */
export function newsClassList(params) {
    return http({
        url: "/api/news/cat",
        data: params
    })
}

/**
 * 获取帮助详情
 */
export function newsDetail(params) {
    return http({
        url: "/api/news/detail",
        data: params
    })
}

/**
 * 获取新闻列表
 */
export function newsCat(params) {
    return http({
        url: "/api/news/cat",
        data: params
    })
}

